$(document).ready(function() {
  
  //description ellipsis
  if($('[data-ellipsis]').length && $('[data-ellipsis]').text().length > 80 ) {
      function ellips(string){

        var maxLength = 80; // maximum number of characters to extract

        //trim the string to the maximum length
        var trimmedString = string.substr(0, maxLength);

        //re-trim if we are in the middle of a word
         trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
         trimmedString += '<button class="o-btn" data-read-more>Read more</button>';
         return trimmedString;

      }

    var collectionDescription = $('[data-ellipsis]');
    var descriptionAll = collectionDescription.text();
    collectionDescription.html(ellips(descriptionAll));
    $(document).on('click touchscreen', '[data-read-more]', function(e){
      e.stopPropagation();
      e.preventDefault();
      collectionDescription.html(descriptionAll + ' <button class="o-btn " data-read-less>Read less</button>');
    });

    $(document).on('click touchscreen', '[data-read-less]', function(e){
        collectionDescription.html(ellips(descriptionAll));
    });
  }
    $(window).scroll(function(){
        if ($(window).scrollTop() >= 100) {
            $('.site-header').addClass('fix-top-mobile');
            $('.main-content ').addClass('fix-top-main');
        }
        else {
            $('.site-header').removeClass('fix-top-mobile');
            $('.main-content ').removeClass('fix-top-main');
        }
    });
});

var readMore = document.querySelector('.js-readmore')
if (readMore) {
  var readMoreButton = readMore.querySelector('.js-show-more')
  var readMoreContent = readMore.querySelector('.js-read-more-content')
  var readLessButton = readMore.querySelector('.js-show-less')
  readMoreButton.addEventListener('click', function (e) {
    e.preventDefault()
    readMoreContent.classList.remove('hidden')
    readMoreButton.classList.add('hidden')
    readLessButton.classList.remove('hidden')
  })
  readLessButton.addEventListener('click', function (e) {
    e.preventDefault()
    readMoreContent.classList.add('hidden')
    readMoreButton.classList.remove('hidden')
    readLessButton.classList.add('hidden')
  })
}